import { useSelector } from 'react-redux';

// Placeholder object to type root reducer before we have all reducers typed

export const useAppSelector = useSelector;